import api from "@/utils/http";

/**
 功能：零星项目配置
 time: 2026/09/12
 **/
export function getDispersedConfig() {
    return api.get('/admin/small_project/getSetConfig')
}

/**
 功能：零星项目列表
 time: 2026/09/12
 **/
export function getDispersedList(data) {
    return api.post('/admin/small_project/getList', data)
}

/**
 功能：保存零星项目（新增/编辑）
 time: 2026/09/12
 **/
export function saveDispersed(data) {
    return api.post('/admin/small_project/eSave', data)
}

/**
 功能：零星项目详情
 time: 2026/09/12
 **/
export function getDispersedDetail(small_project_id) {
    return api.post('/admin/small_project/getDetail', { small_project_id })
}

/**
 功能：删除零星项目
 time: 2026/09/12
 **/
export function deleteDispersed(small_project_id) {
    return api.post('/admin/small_project/del', {small_project_id})
}

/**
 功能：零星项目日志
 time: 2026/09/12
 **/
export function getDispersedLogList(small_project_id) {
    return api.post('/admin/small_project/getLogList', { small_project_id })
}

/**
 功能：维保类型列表
 time: 2026/09/12
 **/
export function getMaintainTypeList(data) {
    return api.post('/admin/small_project_maintain_type/getList', data)
}

/**
 功能：保存维保类型
 time: 2026/09/12
 **/
export function saveMaintainType(data) {
    return api.post('/admin/small_project_maintain_type/eSave', data)
}

/**
 功能：维保类型详情
 time: 2026/09/12
 **/
export function getMaintainTypeDetail(type_id) {
    return api.post('/admin/small_project_maintain_type/getDetail', {type_id})
}

/**
 功能：删除维保类型
 time: 2026/09/12
 **/
export function deleteMaintainType(type_id) {
    return api.post('/admin/small_project_maintain_type/del', {type_id})
}

/**
 功能：批量删除维保类型
 time: 2026/09/12
 **/
export function deleteAllMaintainType(typeIds) {
    return api.post('/admin/small_project_maintain_type/delAll', {typeIds})
}

/**
 功能：维保记录配置
 time: 2026/09/12
 **/
export function getMaintainConfig() {
    return api.get('/admin/small_project_maintain/getSetConfig')
}

/**
 功能：维保记录搜索下拉
 time: 2026/09/12
 **/
export function getMaintainSearchList(data) {
    return api.post('/admin/small_project_maintain/getSearchList', data)
}

/**
 功能：维保记录列表
 time: 2026/09/12
 **/
export function getMaintainList(data) {
    return api.post('/admin/small_project_maintain/getList', data)
}

/**
 功能：保存维保记录（新增/编辑）
 time: 2026/09/12
 **/
export function saveMaintain(data) {
    return api.post('/admin/small_project_maintain/eSave', data)
}

/**
 功能：维保记录详情
 time: 2026/09/12
 **/
export function getMaintainDetail(maintain_id) {
    return api.post('/admin/small_project_maintain/getDetail', { maintain_id })
}

/**
 功能：删除维保记录
 time: 2026/09/12
 **/
export function deleteMaintain(maintain_id) {
    return api.post('/admin/small_project_maintain/del', {maintain_id})
}

/**
 功能：零星项目收入配置
 time: 2026/09/12
 **/
export function getDispersedIncomeConfig() {
    return api.get('/admin/small_project_income/getSetConfig')
}

/**
 功能：零星项目收入列表
 time: 2026/09/12
 **/
export function getDispersedIncomeList(data) {
    return api.post('/admin/small_project_income/getList', data)
}

/**
 功能：保存零星项目收入
 time: 2026/09/12
 **/
export function saveDispersedIncome(data) {
    return api.post('/admin/small_project_income/eSave', data)
}

/**
 功能：零星项目收入审批
 time: 2026/09/12
 **/
export function examineDispersedIncome(data) {
    return api.post('/admin/small_project_income/examineSave', data)
}

/**
 功能：零星项目收入详情
 time: 2026/09/12
 **/
export function getDispersedIncomeDetail(income_id) {
    return api.post('/admin/small_project_income/getDetail', { income_id })
}

/**
 功能：删除零星项目收入
 time: 2026/09/12
 **/
export function deleteDispersedIncome(income_id) {
    return api.post('/admin/small_project_income/del', {income_id})
}

/**
 功能：零星项目支出配置
 time: 2026/09/12
 **/
export function getDispersedExpendConfig() {
    return api.get('/admin/small_project_expend/getSetConfig')
}

/**
 功能：零星项目支出列表
 time: 2026/09/12
 **/
export function getDispersedExpendList(data) {
    return api.post('/admin/small_project_expend/getList', data)
}

/**
 功能：保存零星项目支出
 time: 2026/09/12
 **/
export function saveDispersedExpend(data) {
    return api.post('/admin/small_project_expend/eSave', data)
}

/**
 功能：零星项目支出审批
 time: 2026/09/12
 **/
export function examineDispersedExpend(data) {
    return api.post('/admin/small_project_expend/examineSave', data)
}

/**
 功能：零星项目支出打款
 time: 2026/09/12
 **/
export function payDispersedExpend(data) {
    return api.post('/admin/small_project_expend/paySave', data)
}

/**
 功能：零星项目支出详情
 time: 2026/09/12
 **/
export function getDispersedExpendDetail(expend_id) {
    return api.post('/admin/small_project_expend/getDetail', { expend_id })
}

/**
 功能：删除零星项目支出
 time: 2026/09/12
 **/
export function deleteDispersedExpend(expend_id) {
    return api.post('/admin/small_project_expend/del', {expend_id})
}

/**
 功能：零星项目发票配置
 time: 2026/09/12
 **/
export function getDispersedInvoiceConfig() {
    return api.get('/admin/small_project_invoice/getSetConfig')
}

/**
 功能：零星项目发票列表 kind 1收入发票 2支出发票
 time: 2026/09/12
 **/
export function getDispersedInvoiceList(data) {
    return api.post('/admin/small_project_invoice/getList', data)
}

/**
 功能：保存零星项目发票
 time: 2026/09/12
 **/
export function saveDispersedInvoice(data) {
    return api.post('/admin/small_project_invoice/eSave', data)
}

/**
 功能：零星项目发票审批
 time: 2026/09/12
 **/
export function examineDispersedInvoice(data) {
    return api.post('/admin/small_project_invoice/examineSave', data)
}

/**
 功能：零星项目发票详情
 time: 2026/09/12
 **/
export function getDispersedInvoiceDetail(invoice_id) {
    return api.post('/admin/small_project_invoice/getDetail', { invoice_id })
}

/**
 功能：删除零星项目发票
 time: 2026/09/12
 **/
export function deleteDispersedInvoice(invoice_id) {
    return api.post('/admin/small_project_invoice/del', {invoice_id})
}

/**
 功能：零星项目发票绑定收款/支出记录
 time: 2026/09/13
 **/
export function bindDispersedInvoice(data) {
    return api.post('/admin/small_project_invoice/bindSave', data)
}

/**
 功能：清空零星项目发票绑定
 time: 2026/09/13
 **/
export function clearDispersedInvoice(invoice_id) {
    return api.post('/admin/small_project_invoice/clearSave', {invoice_id})
}

/**
 功能：可绑定的零星项目收入搜索列表
 time: 2026/09/13
 **/
export function getDispersedIncomeSearchList(data) {
    return api.post('/admin/small_project_invoice/getIncomeSearchList', data)
}

/**
 功能：可绑定的零星项目支出搜索列表
 time: 2026/09/13
 **/
export function getDispersedExpendSearchList(data) {
    return api.post('/admin/small_project_invoice/getExpendSearchList', data)
}
